import { useState } from 'react';
import { FiCheckCircle, FiPackage, FiServer, FiShoppingCart, FiStar } from 'react-icons/fi';
import { RESOLVE_PORTFOLIO_MEDIA_URL } from '../../../_Shared/resolveMediaUrl';
import { SalePurchaseModal } from './SalePurchaseModal';

const splitStack = (stack = '') => String(stack)
    .split(/[,|·]/)
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, 4);

const formatPrice = (price, currency = 'ARS') => {
    try {
        return new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: currency || 'ARS',
            maximumFractionDigits: Number(price) % 1 === 0 ? 0 : 2,
        }).format(Number(price || 0));
    } catch {
        return `${currency || 'ARS'} ${Number(price || 0).toLocaleString('es-AR')}`;
    }
};

export const SaleProjectsSection = ({ projects = [], onSubmitOrder }) => {
    const [selectedProject, setSelectedProject] = useState(null);
    if (!projects.length) return null;

    return (
        <section id="proyectos-en-venta" className="PB__section PB__sale_projects_section">
            <div className="PB__sale_projects_glow PB__sale_projects_glow--a" aria-hidden="true" />
            <div className="PB__sale_projects_glow PB__sale_projects_glow--b" aria-hidden="true" />
            <div className="PB__sale_projects_grid" aria-hidden="true" />

            <div className="PB__container PB__relative">
                <div className="PB__section_header PB__sale_projects_header">
                    <div>
                        <h2 className="PB__section_title">proyectos <em>en venta</em>.</h2>
                    </div>
                </div>

                <div className="PB__sale_projects_cards">
                    {projects.map((project) => {
                        const stack = splitStack(project.stack);
                        return (
                            <article className={`PB__sale_project_card ${project.featured ? 'is-featured' : ''}`} key={project.id || project.slug || project.title}>
                                <div className="PB__sale_project_media">
                                    {project.image ? <img src={RESOLVE_PORTFOLIO_MEDIA_URL(project.image)} alt={project.title} /> : <div className="PB__sale_project_placeholder" aria-label="Proyecto sin portada"><FiPackage /></div>}
                                    <span className="PB__sale_project_available"><FiCheckCircle /> Disponible</span>
                                    {project.featured && <span className="PB__sale_project_featured"><FiStar /> Recomendado</span>}
                                </div>

                                <div className="PB__sale_project_body">
                                    <div className="PB__sale_project_stack">{stack.map((item) => <span key={`${project.id}-${item}`}>{item}</span>)}</div>
                                    <h3>{project.title}</h3>
                                    <p>{project.short_description || project.description}</p>
                                    <div className="PB__sale_project_delivery">
                                        <span><FiPackage /> Entrega directa</span>
                                        <span><FiServer /> Deploy opcional</span>
                                    </div>
                                    <div className="PB__sale_project_footer">
                                        <div><small>Precio</small><strong>{formatPrice(project.price, project.currency)}</strong></div>
                                        <button type="button" onClick={() => setSelectedProject(project)}><FiShoppingCart /> Comprar</button>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>

            {selectedProject && (
                <SalePurchaseModal
                    project={selectedProject}
                    onClose={() => setSelectedProject(null)}
                    onSubmit={onSubmitOrder}
                />
            )}
        </section>
    );
};
